export interface IFooterTheme {
	socialLinks: {
		color: string;

		hover: {
			color: string;
		};
	};
}

export const theme: IFooterTheme = {
	socialLinks: {
		color: '',

		hover: {
			color: '',
		},
	},
};
